import { atom } from 'jotai'

import { type DispatchListDetailExEntity } from '@/libs/api'

/**
 * 非配送依頼枠の編集で表示する配車明細情報
 */
export const nonDeliveryDispatchDetailEditAtom =
  atom<DispatchListDetailExEntity | null>(null)

nonDeliveryDispatchDetailEditAtom.debugLabel =
  'nonDeliveryDispatchDetailEditAtom'
